import { useQuery } from '@tanstack/react-query'
import { settingsKeys } from '../../keys'
import { settingsService } from '../../services'
import type { FlexMessagePresetListResponse } from '../../../types'

export default function useQueryGetFlexMessagePresets() {
	return useQuery<FlexMessagePresetListResponse>({
		queryKey: settingsKeys.flexMessagePresets(),
		queryFn: () => settingsService.getFlexMessagePresets(),
	})
}
